import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const apiPrefix = ecom.craft3config.api_prefix || '';
const baseUrl = `${window.location.origin}${apiPrefix}/ecom/api/v1`;

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl }),
  tagTypes: ['availability', 'reservation', 'account'],
  endpoints: () => ({}),
});
